import { format, Locale } from 'date-fns';

const DATE_DISPLAY_FORMAT = 'dd MMMM yyyy';

export default function (date: Date, options: { locale: Locale }): string {
	return format(date, DATE_DISPLAY_FORMAT, options);
}
